export const isValidCanadianPhone = (phone) => {
  const regex = /^(?:\+1\s?)?\(?[2-9][0-9]{2}\)?[-.\s]?[2-9][0-9]{2}[-.\s]?[0-9]{4}$/; //Canadian regex
  return regex.test(phone);
};

//10 digits (3-digit area code   3-digit central office code   4-digit line number)
//  Valid examples:-
          // 4161234567
          // +1 4161234567
          // (416) 123-4567
          // 416-123-4567
          // +1 (416)123-4567